
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ats-roi-calculator",
      function () {
        return require("private-next-pages/ats-roi-calculator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ats-roi-calculator"])
      });
    }
  